<template>
  <div class="childtrackingsystem-parentcontact">
    <div v-if="!isParentContactForm">
      <div class="row row-cols-auto align-items-center bg-white py-3">
      <div class="col fw-bold">Kinderen</div>
        <div class="col">
          <select
              class="form-select form-select-sm"
              @change="childSelect($event)"
          >
            <option value="0">Kies kind</option>
            <option
                v-for="child in selectableChildren"
                :key="child.id"
                :value="child.id"
            >
              {{ child.name }}
            </option>
          </select>
        </div>
        <div
            v-if="isLoading"
            class="modalLoader"
        >
          <img
              src="../../assets/img/loading.gif"
              alt="Loading"
              style="width: 80px; height: 80px;"
          >
        </div>
      </div>

      <div class="row bg-white">
        <div class="col-12">
        <table class="table">
          <thead>
          <tr>
            <th>Observatieformulier</th>
            <th></th>
          </tr>
          </thead>
          <tbody>
          <tr v-bind:key="key" v-for="(form, key) in forms">
            <td><b>{{ form.listTitle }}</b> voor kind <b>{{ form.childName }} </b> ({{ form.childAge }})</td>
            <td class="text-end pe-1">
              <span style="margin-top: 5px; margin-right: 15px;"
                title="Maak verzorger contact formulier aan"
                @click="makeParentContactForm(form.idChildForm)"
              >
                <icon name="parent-contact"></icon>
              </span>
            </td>
          </tr>
          </tbody>
        </table>
          </div>
      </div>
    </div>
    <div v-if="isParentContactForm">
      <div class="row bg-white">
        <div class="col-12 pt-2 text-end">
          <button class="btn btn-outline-secondary" @click="goBack()">Terug</button>
        </div>
      </div>
      <div class="row bg-white">
        <div class="col-11 pt-2 pb-2">
          Notities van het kind <b>{{ childDetails.childName }}</b> op basis van observatieformulier <b>{{listDetails.titel}}</b>
        </div>
        <div class="col-1 pt-2 pb-2 text-end">
          <span
            class="btn btn-sm btn-outline-success"
            title="Bekijk"
            @click="addNote()"
          >
            <icon name="comment-add"></icon>
          </span>
        </div>
      </div>
      <div v-bind:key="key" v-for="(parentContactForm, key) in parentContactForms"
           class="row bg-white shadow mt-1 mb-1 rounded">
        <div class="col-11 pt-2 pb-2">Opgeslagen op {{parentContactForm.updatedAt }} door {{ parentContactForm.updatedBy }}
          <textarea class="form-control-plaintext text-grey" :id="'note-' + key"
                    style="height: 100px;" v-model="parentContactForm.content"></textarea>
        </div>
        <div class="col-1 text-end pt-2 pb-2">
          <span
            class="btn btn-sm btn-outline-success mb-2"
            title="Opslaan notitie"
            @click="saveNote(key)"
          >
            <icon name="comment-save"></icon>
          </span><br>
          <span
            v-if="!parentContactForm.share"
            class="btn btn-sm btn-outline-warning mb-2"
            title="Delen notitie met verzorgers"
            @click="shareNote(key, 1)"
          >
            <icon name="comments"></icon>
          </span>
          <span
            v-if="parentContactForm.share" class="btn btn-sm btn-warning mb-2"
            title="Delen ongedaan maken"
            @click="shareNote(key, 0)"
          >
            <icon name="comments"></icon>
          </span><br>
          <span
            class="btn btn-sm btn-outline-danger"
            title="Verwijderen"
            @click="deleteNote(key)"
          >
            <icon name="comment-delete"></icon>
          </span>
        </div>
      </div>
      <div id="newNote" class="row bg-white shadow mt-1 mb-1 d-none rounded">
        <div class="col-11 pt-2 pb-2">
          <textarea class="form-control-plaintext text-grey" id="note-0"
                    style="height: 100px;" v-model="newNote.content"></textarea></div>
        <div class="col-1 pt-2 pb-2 border-bottom text-end">
          <span
            class="btn btn-sm btn-outline-success"
            title="Opslaan"
            @click="saveNote(0)"
          >
            <icon name="comment-save"></icon>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import icon from "@/components/Icon.vue";

export default {
  name: "childtrackingsystem-parentcontact",
  components: {icon},
  data() {
    return {
      child: null,
      selectableChildren: [],
      forms: [],
      isParentContactForm: false,
      formDetails: [],
      childDetails: [],
      listDetails: [],
      parentContactForms: [],
      newNote: [],
      idChildForm: null
    }
  },
  computed: {
    deviceToken() {
      return this.$store.getters.deviceToken
    },
    session() {
      return this.$store.getters.session
    },
  },
  created() {
    window.novict = {
      device: {
        device_token: this.deviceToken
      },
      session: {
        session_token: this.session.session_token
      }
    }
    this.getResults()
  },
  methods: {
    getResults() {
      this.isLoading = true
      this.$store.commit('REGISTER_ACTIVE_REQUEST')
      // eslint-disable-next-line no-undef
      this.$request.post('/ChildTrackingSystem/forms', {
        child: this.child,
        idEstablishment: this.$store.getters.selectedEstablishment.id,
        idGroup: this.$store.getters.selectedGroupsQueryString,
        showActive: true
      }).then((response) => {
        this.$store.commit('REMOVE_ACTIVE_REQUEST')
        if (response) {
          this.selectableChildren = response.children
          this.forms = response.forms
        }
        this.isLoading = false
      })
    },
    childSelect(event) {
      this.child = event.target.value
      this.getResults()
      return event.target.value
    },
    makeParentContactForm(idChildForm) {
      this.isParentContactForm = true
      this.isLoading = true
      this.$store.commit('REGISTER_ACTIVE_REQUEST')
      // eslint-disable-next-line no-undef
      this.$request.post('/ChildTrackingSystem/getParentContact', {
        idChildForm: idChildForm
      }).then((response) => {
        this.$store.commit('REMOVE_ACTIVE_REQUEST')
        if (response) {
          this.childDetails = response.childDetails
          this.formDetails = response.formDetails
          this.listDetails = response.listDetails
          this.parentContactForms = response.parentContactForms
          this.newNote = response.newNote
          this.idChildForm = idChildForm
        }
        this.isLoading = false
      })
    },
    addNote() {
      document.getElementById("newNote").classList.remove('d-none')
    },
    saveNote(idNote) {
      this.isLoading = true
      this.$store.commit('REGISTER_ACTIVE_REQUEST')
      let contentNote = ''
      if (idNote === 0) {
         contentNote = this.newNote.content
      } else {
         contentNote = this.parentContactForms[idNote].content
      }
      // eslint-disable-next-line no-undef
      this.$request.post('/ChildTrackingSystem/saveParentContact', {
        idChildForm: this.idChildForm,
        idNote: idNote,
        noteContent: contentNote
      }).then((response) => {
        this.$store.commit('REMOVE_ACTIVE_REQUEST')
        if (response.ok) {
          this.makeParentContactForm(this.idChildForm)
          if (idNote === 0) {
            document.getElementById("newNote").classList.add('d-none')
          }
        } else {
          alert(response.error)
        }
        this.isLoading = false
      })
    },
    shareNote(idNote, share) {
      this.isLoading = true
      this.$store.commit('REGISTER_ACTIVE_REQUEST')
      // eslint-disable-next-line no-undef
      this.$request.post('/ChildTrackingSystem/shareParentContact', {
        idChildForm: this.idChildForm,
        idNote: idNote,
        share: share
      }).then((response) => {
        this.$store.commit('REMOVE_ACTIVE_REQUEST')
        if (response.ok) {
          this.makeParentContactForm(this.idChildForm)
        } else {
          alert(response.error)
        }
        this.isLoading = false
      })
    },
    deleteNote(idNote) {
      this.isLoading = true
      this.$store.commit('REGISTER_ACTIVE_REQUEST')
      // eslint-disable-next-line no-undef
      this.$request.post('/ChildTrackingSystem/deleteParentContact', {
        idNote: idNote
      }).then((response) => {
        this.$store.commit('REMOVE_ACTIVE_REQUEST')
        if (response.ok) {
          this.makeParentContactForm(this.idChildForm)
        } else {
          alert(response.error)
        }
        this.isLoading = false
      })
    },
    goBack() {
      this.isParentContactForm = false
    }
  }
}
</script>

<style>
.modalLoader {
  position: absolute;
  z-index: 1;
  left: 0;
  top: 100px;
  width: 100%;
  height: 100%;
  overflow: auto;
  text-align: center;
  vertical-align: middle;
}

.table {
  width: 100%;
}

.table th {
  color: #666;
  background-color: #f0f0f5;
  border-top: 1px solid #ddd !important;
}

.table td {
  border-bottom: 1px solid #ddd !important;
  color: #666;
}
.text-grey {
  padding: 5px;
  color: #666;
}
</style>
